const FINANCIAL_METRICS_EN = Object.freeze({
    "netRevenue": 'Net Revenue',
    "currentAssets": 'Current Assets',
    "totalAssets": 'Total Assets',
    "currentLiabilities": 'Current Liabilities',
    "totalLiabilities": 'Total Liabilities',
    "retainedEarnings": 'Retained Earnings',
    "accountsReceivable": 'Accounts Receivable',
    "debtToAssetRatio": 'Debt to Asset Ratio',
    "quickRatio": 'Quick Ratio',
    "currentRatio": 'Current Ratio',
    "daysSalesOutstanding": 'Days Sales Outstanding',
    "daysPayableOutstanding": 'Days Payable Outstanding',
    "operatingCashFlowRatio": 'Operation Cash Flow Ratio',
    "ebit": 'EBIT'
});

const FINANCIAL_METRICS_ZH_TW = Object.freeze({
    "netRevenue": '營業額',
    "currentAssets": '流動資產',
    "totalAssets": '總資產',
    "currentLiabilities": '流動負債',
    "totalLiabilities": '總負債',
    "retainedEarnings": '保留盈餘',
    "accountsReceivable": '應收賬款',
    "debtToAssetRatio": '資產負債率',
    "quickRatio": '速動比率',
    "currentRatio": '流動比率',
    "daysSalesOutstanding": '應收賬款周轉天數',
    "daysPayableOutstanding": '應付賬款周轉天數',
    "operatingCashFlowRatio": '營業現金流量比率',
    "ebit": '息税前利潤'
});


export { FINANCIAL_METRICS_EN, FINANCIAL_METRICS_ZH_TW };